import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';
import { hasuraClient } from '../utils/graphqlClient';
import { UPDATE_BONUS_RULE_TEAMS_MUTATION } from '../graphql/mutations/primYonetimi';

const parseTeamIds = (formData) =>
  Array.isArray(formData.team_ids)
    ? formData.team_ids
        .map((v) => (typeof v === 'string' ? parseInt(v, 10) : v))
        .filter((v) => Number.isFinite(v))
    : [];

const useBonusRules = () => {
  const { user } = useAuth();

  const dynamicHook = useDynamicEntity({
    entityType: 'bonusRules',
    gqlEntityKey: 'bonus_rules',
    queryName: 'GET_BONUS_RULES_QUERY',
    createMutation: 'CREATE_BONUS_RULE_MUTATION',
    updateMutation: 'UPDATE_BONUS_RULE_MUTATION',
    deleteMutation: 'DELETE_BONUS_RULE_MUTATION',
    transformData: (row) => ({
      ...row,
      company_name: row.company?.name || `Company ${row.company_id}`,
      team_name: (row.rule_teams || [])
        .map((rt) => rt.team?.name)
        .filter(Boolean)
        .join(', ') || '—',
      team_ids: (row.rule_teams || []).map((rt) => rt.team_id),
      // Bitiş opsiyonel: yoksa "süresiz" göster.
      period_label: row.bitis_yil && row.bitis_ceyrek
        ? `${row.baslangic_yil}/Q${row.baslangic_ceyrek} → ${row.bitis_yil}/Q${row.bitis_ceyrek}`
        : `${row.baslangic_yil}/Q${row.baslangic_ceyrek} → süresiz`,
      status: row.is_active ? 'active' : 'inactive',
      companyId: row.company_id,
    }),
    transformFormData: (formData) => {
      const bitisYil = formData.bitis_yil ? parseInt(formData.bitis_yil) : null;
      const bitisCeyrek = formData.bitis_ceyrek ? parseInt(formData.bitis_ceyrek) : null;
      return {
        aciklama: formData.aciklama || null,
        sabit_yuzdelik_aktif: !!formData.sabit_yuzdelik_aktif,
        sabit_yuzdelik_deger: formData.sabit_yuzdelik_aktif
          ? parseFloat(formData.sabit_yuzdelik_deger) || 0
          : null,
        prim_hakedis_esik_orani: parseFloat(formData.prim_hakedis_esik_orani) || 0,
        // Sabit yüzdelik aktifse baz prim oranı kullanılmıyor; form'da gizli olduğu
        // için NaN gelir, 0'a düşüriyoruz (DB CHECK >= 0 geçer).
        baz_prim_orani: formData.sabit_yuzdelik_aktif
          ? 0
          : (parseFloat(formData.baz_prim_orani) || 0),
        baslangic_yil: parseInt(formData.baslangic_yil) || new Date().getFullYear(),
        baslangic_ceyrek: parseInt(formData.baslangic_ceyrek) || 1,
        bitis_yil: Number.isFinite(bitisYil) ? bitisYil : null,
        bitis_ceyrek: Number.isFinite(bitisCeyrek) ? bitisCeyrek : null,
        is_active: formData.status ? formData.status === 'active' : true,
      };
    },
    onSuccess: async (action, entity, formData) => {
      const ruleId = entity?.id;
      if (!ruleId) return;
      const teamIds = parseTeamIds(formData);
      await hasuraClient.mutate(UPDATE_BONUS_RULE_TEAMS_MUTATION, {
        ruleId,
        objects: teamIds.map((team_id) => ({ bonus_rule_id: ruleId, team_id })),
      });
    },
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useBonusRules };
